import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-share-this',
  templateUrl: './share-this.component.html',
  styleUrls: ['./share-this.component.scss']
})
export class ShareThisComponent implements OnInit {
  currentPage = '';
  shareTxt = '';
  shareThisAc = false;
  isFirstLoadShare = true;

  constructor(private route: ActivatedRoute) {
    this.route.url.subscribe( (url) => {
      this.currentPage = window.location.href;
    });
    this.shareTxt = '%20היי,%20בדיוק%20מה%20שצריך!%20';
   }

  ngOnInit() {
    let element = document.getElementsByClassName('online-content-cube-wrapper')[0];
    if (!element) {
      element = document.getElementsByClassName('online-content-cube-wrapper-home')[0];
    }
    if(element){
      element.addEventListener('click', () => {
        this.shareThisAc = false;
      });
    }
    
  }
  shareThis() {
    this.shareThisAc = !this.shareThisAc;
    this.isFirstLoadShare = false;
  }

}
